import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION33: PdfComponent = {
  type: 'section',
  id: 's33',
  title: '33. Costs and Expenses',
  content: [
    {
      type: 'altText',
      id: 's33bullets',
      content: [
        'Each party shall pay its own costs and expenses incurred in connection with the negotiation, preparation, signing and performance of this Agreement (and any documents referred to in it).',
      ],
      boldFirst: false,
    },
  ],
};
